<script lang="ts">
  export let style = 'background: #fff; opacity: 0.5;';

  $: hasDefault = !!$$slots.default;
</script>

<style>
  .loading-wrap {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    justify-content: center;
    z-index: 7999;
  }
  .spin-dot {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .ani{
    -webkit-animation: spinAnimation 1s linear infinite;
  }
  @-webkit-keyframes spinAnimation {
    0% {
      -webkit-transform: rotate(0deg);
    }
    25% {
      -webkit-transform: rotate(90deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    75% {
      -webkit-transform: rotate(270deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
</style>

<div class="loading-wrap pa df aic jcsb br12" {style}>
  <div class="spin-dot df aic" class:ani={hasDefault}>
    {#if hasDefault}
      <i class='iconfont' >&#xe6e1;</i>
    {:else}
      <slot name='rolling'></slot>
    {/if}
  </div>
</div>
